import { CloseCircleOutlined } from '@ant-design/icons';
import { Col, Form, Row, Typography, message } from 'antd';
import { useEffect, useState } from 'react';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import CustomButton from '../../v2-components/Antd/Button';
import CustomCard from '../../v2-components/Antd/Card';
import CustomFormItem from '../../v2-components/Antd/FormItem';
import CustomSelect from '../../v2-components/Antd/Select';
import CustomUpload from '../../v2-components/Antd/Upload';
import ResponseCollapse from '../../v2-components/ResponseCollapse';
import { Links } from './constants/link-examples.constant';
import { messages } from './constants/messages.constant';
import { Options } from './constants/options.constant';
import { states } from './constants/states.constant';
import { boxStatus } from './handle/box-status.handle';
import { importFileAdapter } from './handle/import-file-adapter.handle';
import { Service } from './service';
import './style.css';

const { Title } = Typography;

export default function MigrationPage() {
	const [selectedInfo, setSelectedInfo] = useState(null);
	const [status, setStatus] = useState(null);
	const [migration, setMigration] = useState({});
	const [file, setFile] = useState({});
	const [error, setError] = useState('');
	const [msg, setMsg] = useState('');
	const [responseError, setResponseError] = useState('');

	const { pharmacy } = GetLocalStorageValue(LOCAL_STORAGE.USER);

	useEffect(() => {
		new Service()
			.generatePharmacy(pharmacy)
			.then((res) => {
				console.log('res',res)
				if (res.token) {
					setMigration(res);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}, [pharmacy]);

	const handleUpload = (info) => {
		if (info.fileList.length > 0) {
			setFile(info.fileList[0]);
		}
	};

	const beforeUpload = (file) => {
		const validateTypes = ['.xls', '.xlsx'];
		const extension = file.name?.substring(file.name.lastIndexOf('.')).toLowerCase();
		if (!validateTypes.includes(extension)) {
			return message.error(messages[Enviroment.LANGUAGE].invalid);
		}
		return;
	};
	const handleFileUpload = () => {
		setStatus('uploading');
		const form = new FormData();
		form.append('file', file.originFileObj);

		new Service()
			.importFile(importFileAdapter(file, migration.token, selectedInfo, form))
			.then((res) => {
				if (res.statusCode === 400) {
					setError(messages[Enviroment.LANGUAGE].error);
					setResponseError(res.error.message);
					setStatus(states[Enviroment.LANGUAGE].error);
					return;
				}
				if (res.statusCode === 500) {
					setError(messages[Enviroment.LANGUAGE].error);
					setResponseError(messages[Enviroment.LANGUAGE].error);
					setStatus(states[Enviroment.LANGUAGE].error);
					return;
				}
				setMsg(messages[Enviroment.LANGUAGE].success);
				setStatus(states[Enviroment.LANGUAGE].done);
				console.log(res);
			})
			.catch((error) => {
				setError(messages[Enviroment.LANGUAGE].error);
				setStatus(states[Enviroment.LANGUAGE].error);
				setResponseError(error.message);
				console.log('ERROR', error);
			});
	};

	const handleSelectInfo = (value) => {
		setSelectedInfo(value);
	};

	const handleInnerClick = (e) => {
		e.stopPropagation();
	};
	console.log('selectedInfo', selectedInfo);
	return (
		<div className='migration-container'>
			<CustomCard>
				<Title level={2}>Migración</Title>
				<Col>
					<Form>
						<Row>
							<Title level={4}>Seleccionar el tipo de archivo a subir para la carga masiva</Title>
						</Row>
						<CustomFormItem className="select-information" label="Tipo de información">
							<CustomSelect
								onChange={handleSelectInfo}
								options={Options[Enviroment.LANGUAGE]}
								value={selectedInfo}
								country={Enviroment.LANGUAGE}
								bordered={true}
								placeholder={'Seleccionar tipología'}
							></CustomSelect>
						</CustomFormItem>
						<Row>
							<p>
								Formato del archivo: Excel (xls, xlsx) <br />
								Cabeceras: El archivo debe contener los titulos de cada columna
								<br />
								Ejemplo:
								<a href={Links.global} target="_blank" rel="noopener noreferrer">
									Click Aqui
								</a>
							</p>
						</Row>
						<Row className="center">
							<CustomUpload
								accept=".xls, .xlsx"
								maxCount={1}
								showUploadList={false}
								listType="picture"
								customRequest={handleFileUpload}
								beforeUpload={beforeUpload}
								multiple={false}
								onChange={(info) => handleUpload(info)}
							>
								{boxStatus(status, file?.name, msg)}
								{status === states[Enviroment.LANGUAGE].error && (
									<>
										<Row className="fail">
											<CloseCircleOutlined className="iconFail" />
											<Row className="container">
												<span className="fontBold">Error</span>
												<span className="fontBold">{file?.name}</span>
											</Row>
										</Row>
										<Col style={{ marginBottom: '20px' }} onClick={handleInnerClick}>
											<ResponseCollapse style={{ marginTop: '10px' }} userMessage={error} devMessage={responseError} />
										</Col>
									</>
								)}
								<Row>
									<CustomButton
										disabled={!selectedInfo}
										onClick={() => {
											setFile({});
										}}
										type="primary"
									>
										SUBIR ARCHIVO
									</CustomButton>
								</Row>
							</CustomUpload>
						</Row>
					</Form>
				</Col>
			</CustomCard>
		</div>
	);
}
